import { useState } from 'react';

export const useOrderDetails = () => {
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleView = (row) => {
    setSelectedOrderId(row.id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedOrderId(null);
  };

  return {
    selectedOrderId,
    modalOpen,
    handleView,
    handleCloseModal
  };
};

export default useOrderDetails;

